module.exports = __webpack_public_path__ + "img/tu2.808c39d6.png";